import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "content flex-row-fluid" }
const _hoisted_2 = { class: "page-title d-flex align-items-center flex-wrap me-3 mb-5 mb-lg-0" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "d-flex align-items-center text-dark fw-bolder fs-3 my-5" }, "Thông tin chi tiết trường", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "h-20px border-gray-400 border-start mx-4" }, null, -1)
const _hoisted_5 = { class: "breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1" }
const _hoisted_6 = { class: "breadcrumb-item text-muted" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("a", {
  href: "/dashboard",
  class: "text-muted text-hover-primary"
}, "Dashboard", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-arrow-left me-1" }, null, -1)
const _hoisted_10 = { class: "card mb-xl-8 mb-5" }
const _hoisted_11 = { class: "card-body pt-9 pb-0" }
const _hoisted_12 = { class: "d-flex flex-wrap flex-sm-nowrap mb-6" }
const _hoisted_13 = { class: "flex-grow-1" }
const _hoisted_14 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = { class: "d-flex align-items-center mb-1" }
const _hoisted_17 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-3"
}
const _hoisted_18 = { class: "badge badge-light-success me-auto" }
const _hoisted_19 = { class: "d-flex flex-wrap fw-bold mb-4 fs-5 text-gray-400" }
const _hoisted_20 = { class: "d-flex flex-wrap justify-content-start" }
const _hoisted_21 = { class: "d-flex flex-wrap" }
const _hoisted_22 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_23 = { class: "d-flex align-items-center" }
const _hoisted_24 = {
  key: 0,
  class: "fs-4 fw-bolder"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Số ứng viên", -1)
const _hoisted_26 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = {
  key: 0,
  class: "fs-4 fw-bolder"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-6 text-gray-400" }, "Hồ sơ đã nộp", -1)
const _hoisted_30 = { class: "card" }
const _hoisted_31 = { class: "card-header border-0 pt-2" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder mb-1" }, "Danh sách ứng viên")
  ])
], -1)
const _hoisted_33 = { class: "card-toolbar umt-form" }
const _hoisted_34 = { class: "svg-icon svg-icon-1 position-absolute ms-6" }
const _hoisted_35 = { class: "card-body pt-0 umt-table" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "btn btn-light btn-sm" }, "Xem")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ICountUp = _resolveComponent("ICountUp")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        _withDirectives((_openBlock(), _createElementBlock("li", _hoisted_6, _hoisted_8)), [
          [_directive_permission, [_ctx.Permission.DASHBOARD_VIEW,_ctx.Permission.DASHBOARD]]
        ])
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-sm btn-light ms-auto umt-btn-32",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
      }, [
        _hoisted_9,
        _createTextVNode("Quay lại ")
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, _toDisplayString(_ctx.schoolDetail.class12SchoolName), 1),
                  _createElementVNode("span", _hoisted_18, "Mã trường: " + _toDisplayString(_ctx.schoolDetail.id), 1)
                ]),
                _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.schoolDetail.class12DistrictName) + ", " + _toDisplayString(_ctx.schoolDetail.class12ProvinceName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    (_ctx.schoolDetail.studentTotal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                          _createVNode(_component_ICountUp, {
                            "end-val": _ctx.schoolDetail.studentTotal
                          }, null, 8, ["end-val"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_25
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("div", _hoisted_27, [
                    (_ctx.schoolDetail.adRegTotal)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(_component_ICountUp, {
                            "end-val": _ctx.schoolDetail.adRegTotal
                          }, null, 8, ["end-val"])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_29
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _createElementVNode("div", _hoisted_31, [
        _hoisted_32,
        _createElementVNode("div", _hoisted_33, [
          _createElementVNode("span", _hoisted_34, [
            _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen021.svg" })
          ]),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.search) = $event)),
            class: "form-control form-control-solid w-250px ps-15",
            placeholder: "Tìm kiếm ứng viên..."
          }, null, 512), [
            [_vModelText, _ctx.search]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_35, [
        (_ctx.tableData.length !=0)
          ? (_openBlock(), _createBlock(_component_Datatable, {
              key: 0,
              "table-data": _ctx.tableData,
              total: _ctx.tableData.length,
              currentPage: _ctx.pagination.currentPage,
              "table-header": _ctx.tableHeader,
              "rows-per-page": _ctx.pagination.limit,
              "enable-items-per-page-dropdown": true,
              loading: _ctx.loading
            }, {
              "cell-index": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.index), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-fullName": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.fullName), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-phoneNumber": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.phoneNumber), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-idCard": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.idCard), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-numberProfile": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: _normalizeClass(["menu-link d-block text-center", customer.numberProfile == 0?'text-danger':'text-gray-600'])
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.numberProfile == 0? 'Không có' : customer.numberProfile), 1)
                  ]),
                  _: 2
                }, 1032, ["to", "class"])
              ]),
              "cell-date": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`,
                  class: "menu-link text-gray-600"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(customer.date), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              "cell-viewMore": _withCtx(({ row: customer }) => [
                _createVNode(_component_router_link, {
                  to: `/danhsachungvien/${customer.id}`
                }, {
                  default: _withCtx(() => [
                    _hoisted_36
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]),
              _: 1
            }, 8, ["table-data", "total", "currentPage", "table-header", "rows-per-page", "loading"]))
          : _createCommentVNode("", true)
      ])
    ])
  ])), [
    [_directive_permission, [_ctx.Permission.ADMISSION_REGISTER_VIEW,_ctx.Permission.ADMISSION_REGISTER]]
  ])
}